import React, { FunctionComponent } from 'react';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';

import { DimensionPointCategory } from '@paragon/contract-library';

interface Props {
  value: DimensionPointCategory;
  onChange: (value: DimensionPointCategory) => void;
}

export const DimensionVisibilitySelect: FunctionComponent<Props> = (props) => (
  <FormControl margin="normal" variant="standard">
    <InputLabel htmlFor="dimension-visibility">Dimension Details</InputLabel>
    <Select
      autoWidth
      value={props.value}
      inputProps={{
        id: 'dimension-visibility',
      }}
      onChange={(event) => {
        props.onChange(event.target.value as DimensionPointCategory);
      }}
      label="Dimension Details"
    >
      <MenuItem value="Minimal">Minimal</MenuItem>
      <MenuItem value="General">General</MenuItem>
      <MenuItem value="Detailed">Detailed</MenuItem>
    </Select>
  </FormControl>
);
